import styled from 'styled-components';
import theme from '../../const/theme';


export const BrandContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #FFFFFF;

    @media screen and (max-width: 480px){
        height: auto;
    }
`

export const BrandWrapper = styled.div`
    margin-top: -150px;
    max-width: 1020px;
    width: 100%;
    z-index: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 50px;
    padding-bottom: 50px;

    @media screen and (max-width: 1366px){
        margin-top: -30px;
    }

    @media screen and (max-width: 768px){
        justify-content: center;
        margin-top: 0px;

    }

`

export const BrandIconsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;



    @media screen and (max-width: 991px){
        flex-wrap: wrap;
        padding: 20px;
    }
    @media screen and (max-width: 768px){
        display: none;
    }
`
export const BrandIconsContainerMobile = styled.div`
    display: none;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 768px){
        display: flex;
        flex-wrap: wrap;
        padding: 20px;
    }
`

export const BrandIcon = styled.img`
    //width:${({ small }) => (small ? '120px' : '160px')};
    width:${({ width }) => (width ? width : '100px')};
    margin: 0px 25px;

    @media screen and (max-width: 768px){
        width: 20%;
        margin: 20px 20px;
    }
    @media screen and (max-width: 480px){
        width: ${({ width }) => (width ? width : '30%')};
        margin: 15px 20px;
    }
`

